import { useSelector } from 'react-redux';
import { MgState } from '@types';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { registeredRouteSelector } from '@selectors/app/registeredRouteSelector';

/*
  The component is for any route out of registered routes
  It does not do any render logic, just redirection
 */
export const RouteChecker = () => {
  const navigate = useNavigate();

  const isLoggedIn = useSelector<MgState, boolean>(({ auth }) => auth.isLoggedIn);
  const registeredRoute = useSelector(registeredRouteSelector);

  useEffect(() => {
    if (isLoggedIn) {
      if (registeredRoute) {
        navigate(registeredRoute);
        return;
      }
    }
  }, [isLoggedIn, registeredRoute]);

  return <></>;
};
